"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function truncateText(text, targetLength, ellipsis = '...') {
    const trimmedText = text.trim();
    if (targetLength >= trimmedText.length) {
        return [trimmedText, false];
    }
    const textAtLimit = trimmedText.slice(0, targetLength - ellipsis.length);
    const wordBreakIndex = textAtLimit === null || textAtLimit === void 0 ? void 0 : textAtLimit.lastIndexOf(' ');
    if (wordBreakIndex === -1) {
        return [`${textAtLimit}...`, true];
    }
    const truncatedText = textAtLimit === null || textAtLimit === void 0 ? void 0 : textAtLimit.slice(0, wordBreakIndex);
    const hasMoreText = ((truncatedText === null || truncatedText === void 0 ? void 0 : truncatedText.length) || 0) < (trimmedText.length || 0);
    const textToDisplay = hasMoreText ? `${truncatedText.replace(/[^a-zA-Z0-9]*$/g, '')}${ellipsis}` : text;
    return [textToDisplay, hasMoreText];
}
exports.default = truncateText;
